module.exports = __webpack_public_path__ + "img/mouse.6bbbe120.svg";